module.exports = __webpack_public_path__ + "static/media/logo1.30a0afbe.png";